export const getHeadingIdFromIdx = (headingIndex: number) => `heading-${headingIndex + 1}`;
export const getHeadingIdxFromId = (headingId: string) => Number(headingId.split("-")[1]) - 1;
